import React, { useContext, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { DirectionalHint, Icon } from '@fluentui/react';
import '../style.css';
import { useSelector } from 'react-redux';
import { enum__AppElementType, enum_ENUM_dIcono_Revision, enum_ENUM_ICONO_REVISION, enum_ENUM_TIPO_RESPUESTA } from '../../../common/Dictionaries';
import { isNullUndefined, isNullUndefinedOrEmptyOrNegative } from '../../../common/Helpers';
import PropTypes from 'prop-types';
import ApprovePartieDiPanel from './ApprovePartieDiPanel';
import { __GetClientRoleCode } from '../../../common/CommonFuctions';
import MainAppContext from '../../../MainAppContext';

const DynamicRevisionFlujoEdP = (props) => {
    const { _edpPrepareHeader: edpPrepareHeader } = useSelector((state) => state.edpPreparationState);
    const contextSite = useContext(MainAppContext);

    const { 
        inputParam_ElementId = null,
        inputParam_EdPId = null,
    } = props;

    const [calloutVisibleIndex, setCalloutVisibleIndex] = useState(null);
    const [isAprovePanelOpen, setIsAprovePanelOpen] = useState(false);
    const [revisionObj, setRevisionObj] = useState(false);

    const onOpenAprovePanel = (revision, _tipo_aprobacion_rfa_adn) => {
        setCalloutVisibleIndex(_tipo_aprobacion_rfa_adn);
        setRevisionObj(revision);
        setIsAprovePanelOpen(true);
    }

    const getIconoRevision = (revision, tipo_revision_dinamica) => {
        console.log();
        let global_control = <></>;

        if (enum_ENUM_ICONO_REVISION.NINGUNO !== revision.iconoRevision) {
            console.log();
            global_control = revision.iconoTipo === 'div'
            ?   <div   type='button' id={`${`revision_icc_lcc_${tipo_revision_dinamica}`}`} className={`m-auto button-estados ${enum_ENUM_dIcono_Revision.find(x => x.key === revision.iconoRevision).value}`}  />
            :   <input type='button' id={`${`revision_icc_lcc_${tipo_revision_dinamica}`}`} className={`m-auto button-estados ${enum_ENUM_dIcono_Revision.find(x => x.key === revision.iconoRevision).value}`} onClick={ () => onOpenAprovePanel(revision, tipo_revision_dinamica) } />
        }
        else {
            console.log();
            global_control = <></>
        }

        return  !isNullUndefinedOrEmptyOrNegative(global_control) ?
        <>
            {   global_control   }
        </> : <></>
    }

    return (
        <Row className='text-center tablaAprobacion'>
            <Col className='titAprobacion my-auto'>Revisión</Col>
            {
                edpPrepareHeader.l_etapas_revision.filter(x => x.revisionDinamica === true).map((revision, idx2) => 
                    <>
                        <Col className='col-aprobacion'>
                            <Row><Col>{ __GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, revision.apellido) }</Col></Row>
                            <Row>
                                <Col>
                                    {
                                        getIconoRevision(revision, `${revision.apellido}_${enum_ENUM_TIPO_RESPUESTA.ADN}`)
                                    }
                                </Col>
                            </Row>
                        </Col>
                        {
                            idx2 !== edpPrepareHeader.l_etapas_revision.filter(x => x.revisionDinamica === true).length -1 &&
                            <Col className='my-auto p-0'><Icon iconName='ChevronRightSmall' /></Col>
                        }
                    </>
                )
            }
            {
                revisionObj && isAprovePanelOpen === true &&
                <ApprovePartieDiPanel
                    inputParam_ElementId={inputParam_ElementId}
                    inputParam_EdPId={inputParam_EdPId}
                    inputParam_DialogTitleText={''}
                    inputParam_TargetControlId={`#${`revision_icc_lcc_${calloutVisibleIndex}`}`}
                    inputParam_SetCalloutVisibleIndex={setCalloutVisibleIndex}
                    inputParam_IsPanelOpen={isAprovePanelOpen}
                    inputParam_SetterIsPanelOpen={setIsAprovePanelOpen}
                    inputParam_VerRevision={edpPrepareHeader.verRevision}
                    inputParam_RolTipoRespuestaId={edpPrepareHeader.rolTipoRespuestaRevision}
                    inputParam_RolMatrizEtapaFlujo={edpPrepareHeader.rolMatrizEtapaFlujo}
                    inputParam_EstadoPagoPartidaId={null}
                    inputParam_PartidaId={null}
                    inputParam_EstadoPagoCompuestaDiId={null}
                    inputParam_Iteracion={edpPrepareHeader.iteracioN_EP}
                    inputParam_DisplayDirection={DirectionalHint.leftBottomEdge}
                    inputParam_RefreshPage={true}
                    inputParam_EditMode={false}

                    inputParam_EdpIatrizEtapaId={revisionObj.id}
                    inputParam_TipoRespuestaId={!isNullUndefined(edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'revision')) ? edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'revision').tipo_respuesta_id : 0}
                />
            }
        </Row>
    );
};

DynamicRevisionFlujoEdP.propTypes = {
    inputParam_ElementId: PropTypes.number,
    inputParam_EdPId: PropTypes.number,
};

export default DynamicRevisionFlujoEdP;